module.exports = __webpack_public_path__ + "static/img/G.7af5571.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl/G.png
// module id = yD0m
// module chunks = 0